import { newFocus as E, NEW_FOCUS as F } from "./solver.js";
import { getFocusableNodes as p } from "./utils/DOMutils.js";
import { getAllAffectedNodes as I } from "./utils/all-affected.js";
import { asArray as h, getFirst as x } from "./utils/array.js";
import { pickAutofocus as b } from "./utils/auto-focus.js";
import { getActiveElement as y } from "./utils/getActiveElement.js";
import { isNotAGuard as g, isDefined as C } from "./utils/is.js";
import { getTopCommonParent as P, allParentAutofocusables as A } from "./utils/parenting.js";
var k = function(o, u) {
  var t = /* @__PURE__ */ new Map();
  return u.forEach(function(e) {
    return t.set(e.node, e);
  }), o.map(function(e) {
    return t.get(e);
  }).filter(C);
}, W = function(o, u) {
  var t = y(h(o).length > 0 ? document : x(o).ownerDocument), e = I(o).filter(g), w = P(t || o, o, e), a = /* @__PURE__ */ new Map(), f = p(e, a), c = f.filter(function(r) {
    var n = r.node;
    return g(n);
  });
  if (c[0]) {
    var d = p([w], a).map(function(r) {
      var n = r.node;
      return n;
    }), m = k(d, c), s = m.map(function(r) {
      var n = r.node;
      return n;
    }), v = m.filter(function(r) {
      var n = r.tabIndex;
      return n >= 0;
    }).map(function(r) {
      var n = r.node;
      return n;
    }), i = E(s, v, d, t, u);
    if (i === F) {
      var l = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        b(f, v, A(e, a)) || b(f, s, A(e, a))
      );
      if (l)
        return { node: l };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return i === void 0 ? i : m[i];
  }
};
export {
  W as focusSolver
};
